import { Capacitor } from '@capacitor/core';
import { Geolocation as CapacitorGeolocation } from '@capacitor/geolocation';

function _isNativeApp() {
  try {
    return Capacitor.isNativePlatform();
  } catch (e) {
    return false;
  }
}

function _getPositionViaCapacitor(options) {
  return CapacitorGeolocation.getCurrentPosition(options).then(function (pos) {
    var coords = pos && pos.coords;
    if (!coords || !coords.latitude || !coords.longitude) {
      return Promise.reject("Invalid GPS response from Capacitor");
    }
    return coords.latitude.toFixed(4) + "," + coords.longitude.toFixed(4);
  });
}

function _getPositionViaNavigator(options) {
  return new Promise(function (resolve, reject) {
    if (!navigator.geolocation) {
      return reject("Geolocation not supported");
    }
    navigator.geolocation.getCurrentPosition(
      function (pos) {
        var coords = pos && pos.coords;
        if (!coords || !coords.latitude || !coords.longitude) {
          reject("Invalid GPS response");
          return;
        }
        resolve(coords.latitude.toFixed(4) + "," + coords.longitude.toFixed(4));
      },
      function (error) {
        reject(error);
      },
      options
    );
  });
}

export var VcFindMyLocation = (function () {
    

    return {

      lookupLocation:function() {
        return new Promise((resolve, reject) => {

          
          fetch('https://api.ipdata.co/?api-key=2a3ba97e6c19d40545bdd9942b0d1cd06da89daeedadf02b3ed83929', {
            method: 'GET', 
            mode: 'cors',
            cache: 'no-cache', 
            headers: {
            
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'strict-origin-when-cross-origin', 
          }).then(response => {
              if (!response.ok) {
                throw response;
              }
              
              return response.json();
          }).then(response => {

            var pieces=[];
            if (response.city) pieces.push(response.city);
            
            if (response.region_code) {
              pieces.push(response.region_code);
            } else if(response.region) {
              pieces.push(response.region);
            }
            if (response.country_code) {
              pieces.push(response.country_code);
            } else if(response.country_name) {
              pieces.push(response.country_name);
            }
            
            var address="";
            
            for (var i=0;i<pieces.length;i++) {
              if (address.length>0) address+=", ";
              address+=pieces[i];
            }

            resolve({
              lat:response.latitude,
              lon:response.longitude,
              address:address,
            });
          
          }).catch((errorResponse) => {
              if (errorResponse.text) {
                  errorResponse.text().then( errorMessage => {
                      reject(errorMessage);
                  })
              } else {
                  reject("An error occurred retrieving the data");
              }  
          });
        });
      },

      findMyLocation:function(useGps) {
        var self = this;
        return new Promise((resolve, reject) => {
          if (useGps) {
            var isNative = _isNativeApp();
            console.log("Finding location with GPS" + (isNative ? " (Capacitor native)" : " (browser)"));
            
            var fastOptions = {
              enableHighAccuracy: false,
              timeout: 3000,
              maximumAge: 300000
            };
            var accurateOptions = {
              enableHighAccuracy: true,
              timeout: 10000,
              maximumAge: 300000
            };

            // Try fast (low-accuracy) first, fall back to high-accuracy
            var gpsGet = isNative ? _getPositionViaCapacitor : _getPositionViaNavigator;
            gpsGet(fastOptions).then(function (coords) {
              resolve(coords);
            }).catch(function () {
              gpsGet(accurateOptions).then(function (coords) {
                resolve(coords);
              }).catch(function (error) {
                console.log("GPS error, falling back to IP location:", error);
                self.findMyLocation(false)
                  .then(resolve)
                  .catch(reject);
              });
            });
            
            return;
          }
          console.log("Finding location with computer location");
          fetch('https://api.ipdata.co/?api-key=2a3ba97e6c19d40545bdd9942b0d1cd06da89daeedadf02b3ed83929', {
            method: 'GET', 
            mode: 'cors',
            cache: 'no-cache', 
            headers: {
            //'Content-Type': 'application/json'
            // 'Content-Type': contentType,
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'strict-origin-when-cross-origin', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            //body: JSON.stringify(postdata) // body data type must match "Content-Type" header
            // body: data
          }).then(response => {
              if (!response.ok) {
                throw response;
              }
              
              return response.json();
          }).then(response => {

            var pieces=[];
            if (response.city) pieces.push(response.city);
            
            if (response.region_code) {
              pieces.push(response.region_code);
            } else if(response.region) {
              pieces.push(response.region);
            }
            if (response.country_code) {
              pieces.push(response.country_code);
            } else if(response.country_name) {
              pieces.push(response.country_name);
            }
            
            var address="";
            
            for (var i=0;i<pieces.length;i++) {
              if (address.length>0) address+=", ";
              address+=pieces[i];
            }

            resolve(address);
          
          }).catch((errorResponse) => {
              console.log("Error retrieving location by computer address:"+errorResponse) 
              if (errorResponse.text) {
                  errorResponse.text().then( errorMessage => {
                      reject(errorMessage);
                  })
              } else {
                  reject("An error occurred retrieving the data");
              }  
          });
        });
      }
    }
}());